var styles = {"totalPrice":"ep-pricing-module-total-price-dG90Y"};

export { styles as default };
//# sourceMappingURL=ep-pricing-esm-components-total-price-total-price.module.scss.js.map
